import util from "../../../util/util";

export default {
  props: {
    titles: {
      type: Array,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    rowNum: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    fromOrder: Boolean,
    backgroundHover: Boolean,
    narrowly: Boolean,
    striped: Boolean,
    showDetail: Boolean
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    getStyle: function (style) {
      let st = {};
      if (util.getWidthWindow() <= 740) {
        for (let option in style) {
          st[option] = style[option];
        }
        st.width = "100%";
        return st;
      } else {
        return style;
      }
    },
    clickRowCard: function () {
      this.$emit("clickRowCard", this.rowNum);
    }
  }
};
